// extracted by mini-css-extract-plugin
export default {"properties":"PropertiesContainer_properties__Vgp1y","propertyHeader":"PropertiesContainer_propertyHeader__qKW6R","grid":"PropertiesContainer_grid__HIiJy"};